import React from 'react';
import InformationsPratiques from '../components/InformationsPratiques';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <InformationsPratiques />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
